import store from 'store';
import { getLogger } from 'utils/logger';
import { Config, ENVIRONMENT } from 'utils/webappConfig';
import { getFeatureFlag } from 'utils/featureFlags/selectors';

import { getWebSocketQCSMessage, setWebSocketQCSReadyState } from './webSocketQCSActions';

const log = getLogger('data/webSocketQCS');

let socket;

const onclose = (_event) => {
  log.debug('closed: ', socket.readyState);
  socket = undefined;
  const reconnect = getFeatureFlag(store.getState(), 'webSocketQcs');
  if (reconnect > 0) {
    setTimeout(() => {
      if (!socket || socket.readyState === WebSocket.CLOSED || socket.readyState === WebSocket.CLOSING) {
        open();
      }
    }, reconnect);
  }
};

const onerror = (event) => {
  log.debug('server error: ', event.data);
};

const onmessage = (event) => {
  log.debug('server message: ', event.data);

  let message = event.data;
  if (event.data) {
    try {
      message = event.data ? JSON.parse(event.data) : undefined;
    } catch (e) {
      assert(false, 'WS message\ndata = %s\nerror = %s', JSON.stringify(event.data), e.toString?.());
    }
  }

  store.dispatch(getWebSocketQCSMessage(message));
};

const onopen = () => {
  log.debug('server opened: ', socket.readyState);
  store.dispatch(setWebSocketQCSReadyState(socket.readyState));
};

export const open = () => {
  if (!socket && Config.environments[ENVIRONMENT].websocket_qcs_url) {
    socket = new WebSocket(Config.environments[ENVIRONMENT].websocket_qcs_url);
    socket.onclose = onclose;
    socket.onerror = onerror;
    socket.onmessage = onmessage;
    socket.onopen = onopen;
  }
};

export const send = (message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(message);
  }
};

export const close = (code, reason) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.close(code, reason);
  }
};
